module.exports = __webpack_public_path__ + "static/img/wechatPay.3a62937.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/wechatPay.png
// module id = 3146
// module chunks = 1